window.mascaraDecimaisComponent = {
    quantidadeCasasDecimaisVenda: null, // FNX-4579; FNX-4604; FNX-4637 - Performance
    quantidadeCasasDecimaisCompra: 2,
    quantidadeCasasDecimaisQuantidade: 3,


    iniciar: function () {

        var self = this;
        
        if (self.quantidadeCasasDecimaisVenda === null) {
            global.ajax({
                url: "/Comum/ObterParametros",
                type: "post",
                contentType: "application/json",
                blockUI: false,
                data: global.toJSONString({
                    parametros: [
                        'CASAS_DECIMAIS_PRECO_VENDA',
                        'NDECPRUNIE',
                        'ORCAMENTO_MASCARA_QUANTIDADE'
                    ]
                }),
                success: function (data) {
                    if (!data) {
                        return;
                    }
                    mascaraDecimaisComponentBuscouParametros = true;

                    $.each(data,
                        function () {
                            if (!this.Valor) {
                                return true;
                            }
                            switch (this.Nome.trim()) {
                                case 'CASAS_DECIMAIS_PRECO_VENDA':
                                    self.quantidadeCasasDecimaisVenda = this.Valor;
                                    if (self.quantidadeCasasDecimaisQuantidade > 5) { self.quantidadeCasasDecimaisQuantidade = 5 }
                                    break;
                                case 'NDECPRUNIE':
                                    self.quantidadeCasasDecimaisCompra = this.Valor;
                                    break;
                                case 'ORCAMENTO_MASCARA_QUANTIDADE':
                                    var mascara = this.Valor;

                                    self.quantidadeCasasDecimaisQuantidade = mascara.indexOf(',') != -1
                                        ? mascara.length - (mascara.indexOf(',') + 1)
                                        : 0;
                                    if (self.quantidadeCasasDecimaisQuantidade > 3) { self.quantidadeCasasDecimaisQuantidade = 3 }

                                    break;
                            }
                        });
                    if (self.tidadeCasasDecimaisVenda === null)
                        self.quantidadeCasasDecimaisVenda = 2;  // FNX-4579; FNX-4604; FNX-4637 - Performance
                }
            });
        }

    },

    aplicarRegion: function (region, config) {

        if (!(region instanceof jQuery)) {
            region = $(region);
        }

        $('[mask]', region).each(function () {
            mascaraDecimaisComponent.aplicar(this, config);
        });

    },

    aplicar: function (el, config) {

        if (!el) {
            return;
        }

        var $el = el;

        if (!($el instanceof jQuery)) {
            $el = $(el);
        }

        var mask = $el.attr('mask');

        if (mask != 'precovenda' &&
            mask != 'precocompra' &&
            mask != 'quantidade' &&
            mask != 'Numero2CasasDecimais' &&
            mask != 'Numero3CasasDecimais')
            {
            return;
        }

        var cfg = $el.attr('mask-config');

        if (cfg) {
            config = $.extend(eval("({" + cfg + "})"), config);
        }

        if (!config) {
            config = {};
        }

        switch (mask) {
            case 'precovenda':
                config.quantidadeCasasDecimais = this.quantidadeCasasDecimaisVenda;
                if (config.dinheiro == undefined) {
                    config.dinheiro = true;
                }
                break;
            case 'precocompra':
                config.quantidadeCasasDecimais = this.quantidadeCasasDecimaisCompra;
                if (config.dinheiro == undefined) {
                    config.dinheiro = true;
                }
                break;
            case 'quantidade':
                config.quantidadeCasasDecimais = this.quantidadeCasasDecimaisQuantidade;
                if (config.dinheiro == undefined) {
                    config.dinheiro = false;
                }
                break;
            case 'Numero2CasasDecimais':
                config.quantidadeCasasDecimais = 2;
                if (config.dinheiro == undefined) {
                    config.dinheiro = false;
                }
                break;
            case 'Numero3CasasDecimais':
                config.quantidadeCasasDecimais = 3;
                if (config.dinheiro == undefined) {
                    config.dinheiro = false;
                }
                break;
        }

        this.formatarInput($el, config);
        this.formatarColunaGrid($el, config);
    },

    formatarInput: function (el, config) {
        if (!el.is('input')) {
            return;
        }

        var val = config && config.val ? config.val : el.val();
        var quantidadeCasasDecimais = config != null ? config.quantidadeCasasDecimais : 2;
        el.val(this.formatar(val, config));

        if ((config && config.aplicar) || (!el.attr('mask-decimais') && (!(el.parents('div.modal[role=dialog]').length > 0 && !el.is(':visible'))))) {

            global.applyNumericMask({
                element: el[0],
                digits: quantidadeCasasDecimais,
                ativarNavegacaoGridItens: el.parents('tr.clicavel').length > 0
            });
            el.attr('mask-decimais', 'true');
        }
    },

    formatarColunaGrid: function (el, config) {
        if (!el.is('td') && !el.is('th')) {
            return;
        }
        var val = config && config.val ? config.val : el.text();
        el.text(this.formatar(val, config));
    },

    formatar: function (valor, config) {

        if (!valor) {
            return valor;
        }

        var val;
        if (typeof (valor) == 'string') {

            valor = global.replaceAll(valor, accounting.settings.currency.symbol, '');

            if (valor.indexOf(',') != -1) {
                val = parseFloat(global.replaceAll(global.replaceAll(valor, '.', ''), ',', '.'));
            } else {
                val = parseFloat(valor);
            }
        } else {
            val = valor;
        }

        var dinheiro = config != null ? config.dinheiro : false;
        var quantidadeCasasDecimais = config != null ? config.quantidadeCasasDecimais : 2;

        return dinheiro
            ? global.formatMoney(val, quantidadeCasasDecimais)
            : global.formatNumber(val, quantidadeCasasDecimais);
    },

    removerRegion: function (el) {

        var $el = el;

        if (!(el instanceof jQuery)) {
            $el = $(el);
        }

        var masks = $('[mask]', $el);

        var self = this;
        $.each(masks,
            function () {
                self.remover(this);
            });
    },

    remover: function (el) {

        if (!el) {
            return;
        }

        var $el = el;

        if (!(el instanceof jQuery)) {
            $el = $(el);
        }

        var mask = $el.attr('mask');

        if (mask != 'precovenda' &&
            mask != 'precocompra' &&
            mask != 'quantidade') {
            return;
        }

        $el.inputmask('remove');
    }

};

$(document).ready(function() {
    if (window.location.pathname != "/Login") {
        mascaraDecimaisComponent.iniciar()
    }
});


(function ($) {

    var modalCallback = $.fn.modal;
    var koWriteValueCallback = ko.selectExtensions.writeValue;
    var koSetTextContent = ko.utils.setTextContent;

    $("input").on('focus', function () { $(this).select(); });

    $.fn.modal = function () {
        var result = modalCallback.apply(this, arguments);
        var modal = this;
        this.on('shown.bs.modal',
            function (e) {
                mascaraDecimaisComponent.aplicarRegion(modal, { aplicar: true });
            });

        this.on('hidden.bs.modal',
            function (e) {
                mascaraDecimaisComponent.removerRegion(modal);
            });

        return result;
    };

    ko.selectExtensions.writeValue = function () {
        var result = koWriteValueCallback.apply(this, arguments);
        var el = arguments && arguments.length > 0
            ? arguments[0]
            : null;

        if (el) {
            mascaraDecimaisComponent.aplicar(el,
            {
                val: arguments && arguments.length > 1
                    ? (ko.isObservable(arguments[1]) ? arguments[1]() : arguments[1])
                    : null
            });
        }
        return result;
    }

    ko.utils.setTextContent = function () {
        var result = koSetTextContent.apply(this, arguments);
        var el = arguments && arguments.length > 0
            ? arguments[0]
            : null;

        if (el) {
            mascaraDecimaisComponent.aplicar(el,
            {
                val: arguments && arguments.length > 1
                    ? (ko.isObservable(arguments[1]) ? arguments[1]() : arguments[1])
                    : null
            });
        }
        return result;
    };

}(jQuery));
